module.exports = __webpack_public_path__ + "static/media/CLEAN&CLEAR.090dec11.png";